"use strict";

module.exports = function (column) {
  return this.query.hasOwnProperty(column) && this.opts.dateColumns.indexOf(column) == -1 && !this.opts.listColumns.hasOwnProperty(column);
};


//////////////////
// WEBPACK FOOTER
// ./~/vue-tables-2/compiled/methods/is-text-filter.js
// module id = 1615
// module chunks = 64